<template>
  <form>
    <v-row class="py-0">
      <v-col class="py-0" cols="12" sm="12" md="11" lg="11">
        <form-edit
          :form="subconInvoice"
          ref="formEdit"
          :subcons="subcons"
          :accounts="accounts"
          v-if="!edit"
        ></form-edit>
        <detail :id="id" :item="subconInvoice" :spk="spk" v-if="edit"></detail>
      </v-col>
      <v-col cols="12" sm="12" md="1">
        <v-row class="py-0 mb-2" v-if="!edit">
          <v-col cols="12" class="py-0">
            <v-tooltip bottom>
              <template v-slot:activator="{ on }">
                <v-btn
                  v-if="$rbac.can('subcon-invoice.update')"
                  color="success"
                  v-on="on"
                  @click="updateItem"
                >
                  <v-icon>
                    mdi-content-save
                  </v-icon>
                </v-btn>
              </template>
              <span>Save</span>
            </v-tooltip>
          </v-col>
        </v-row>
        <v-row
          class="py-0 mb-2"
          v-if="edit && subconInvoice.status === 'Outstanding' && !subconInvoice.hidden"
        >
          <v-col cols="12" class="py-0">
            <v-tooltip bottom>
              <template v-slot:activator="{ on }">
                <v-btn
                  v-if="$rbac.can('subcon-invoice.update')"
                  color="success"
                  v-on="on"
                  @click="editItem"
                >
                  <v-icon>
                    mdi-pencil
                  </v-icon>
                </v-btn>
              </template>
              <span>Edit</span>
            </v-tooltip>
          </v-col>
        </v-row>
        <v-row class="py-0 mb-2" v-if="edit && !subconInvoice.hidden">
          <v-col cols="12" class="py-0">
            <v-tooltip bottom>
              <template v-slot:activator="{ on }">
                <v-btn color="warning" v-on="on" @click="openUpdateTaxDate">
                  <v-icon>
                    mdi-update
                  </v-icon>
                </v-btn>
              </template>
              <span>Update Tax Date</span>
            </v-tooltip>
          </v-col>
        </v-row>
        <v-row
          class="py-0 mb-2"
          v-if="edit && subconInvoice.status === 'Outstanding' && !subconInvoice.hidden"
        >
          <v-col cols="12" class="py-0">
            <v-tooltip bottom>
              <template v-slot:activator="{ on }">
                <v-btn color="error" v-on="on" @click="dialogDelete">
                  <v-icon>
                    mdi-delete
                  </v-icon>
                </v-btn>
              </template>
              <span>Delete</span>
            </v-tooltip>
          </v-col>
        </v-row>
        <v-row class="py-0 mb-2" v-if="!edit">
          <v-col cols="12" class="py-0">
            <v-tooltip bottom>
              <template v-slot:activator="{ on }">
                <v-btn color="error" v-on="on" @click="cancel">
                  <v-icon>
                    mdi-close
                  </v-icon>
                </v-btn>
              </template>
              <span>Close</span>
            </v-tooltip>
          </v-col>
        </v-row>
        <v-row class="py-0 mb-2" v-if="edit">
          <v-col cols="12" class="py-0">
            <v-tooltip bottom>
              <template v-slot:activator="{ on }">
                <v-btn color="primary" v-on="on" @click="back">
                  <v-icon>
                    mdi-arrow-left
                  </v-icon>
                </v-btn>
              </template>
              <span>Back</span>
            </v-tooltip>
          </v-col>
        </v-row>
        <v-row class="py-0 mb-2" v-if="edit">
          <v-col cols="12" class="py-0">
            <v-tooltip bottom>
              <template v-slot:activator="{ on }">
                <v-btn color="blue-grey" dark v-on="on" @click="dialogAuditHistory = true">
                  <v-icon>mdi-history</v-icon>
                </v-btn>
              </template>
              <span>History</span>
            </v-tooltip>
          </v-col>
        </v-row>
      </v-col>
    </v-row>
    <dialog-delete
      :id="id"
      :dialog="dialog"
      :invoiceNumber="subconInvoice.invoiceNumber"
      title="Subcon Invoice"
      @deleteItem="deleteItem"
      @close="close"
    ></dialog-delete>
    <dialog-update-tax-date
      :dialog="dialogTax"
      :form="subconInvoice"
      @save="updateTaxDate"
      @close="close"
    ></dialog-update-tax-date>
    <dialog-audit-history
      :dialog="dialogAuditHistory"
      entity-type="SubconInvoice"
      :entity-id="id"
      @close="dialogAuditHistory = false"
    ></dialog-audit-history>
  </form>
</template>

<script>
import Detail from "./DetailSubconInvoice";
import FormEdit from "./FormSubconInvoice";
import DialogDelete from "@/components/DialogDelete";
import DialogUpdateTaxDate from "@/components/DialogUpdateTaxDate.vue";
import DialogAuditHistory from "@/components/DialogAuditHistory.vue";

export default {
  name: "purchase-other-invoice-view",
  components: {
    Detail,
    "form-edit": FormEdit,
    "dialog-delete": DialogDelete,
    DialogUpdateTaxDate,
    DialogAuditHistory,
  },
  props: {
    id: {
      type: Number,
      default: () => undefined,
    },
  },
  data: () => ({
    edit: true,
    dialog: false,
    dialogTax: false,
    dialogAuditHistory: false,
    accounts: [],
    subcons: [],
    subconInvoice: {},
    spk: "",
  }),
  methods: {
    async getSubconInvoice() {
      await this.$store.dispatch("subconInvoice/getById", this.id).then(async response => {
        this.subconInvoice = response.data;
      });
    },
    async getChartOfAccount() {
      const response = await this.$store.dispatch("chartOfAccount/getOtherAccounts");
      if (response.status === 200) {
        this.accounts = response.data;
      }
    },
    async getSubcon() {
      const response = await this.$store.dispatch("subconInvoice/getSubcon");
      if (response.status === 200) {
        this.subcons = response.data;
      }
    },
    back() {
      this.$router.go(-1);
    },
    editItem() {
      this.edit = false;
    },
    updateItem() {
      this.$refs.formEdit.update();
    },
    dialogDelete() {
      this.dialog = true;
    },
    deleteItem(id) {
      this.$store.dispatch("subconInvoice/delete", id);
    },
    close() {
      this.dialog = this.dialogTax = false;
    },
    cancel() {
      this.getSubconInvoice();
      this.edit = true;
    },
    openUpdateTaxDate() {
      this.dialogTax = true;
    },
    async updateTaxDate(item) {
      this.$store.commit("SET_LOADER", true);
      await this.$store
        .dispatch("subconInvoice/updateTaxDate", item)
        .then(() => {
          this.$store.commit("SET_LOADER", false);
          window.location.reload();
        })
        .catch(() => {
          this.$store.dispatch("toast", {
            type: "error",
            message: "Ada masalah dengan aplikasi, mohon hubungi admin aplikasi",
          });
          this.$store.commit("SET_LOADER", false);
        });
    },
    async getInitialData() {
      this.$store.commit("SET_LOADER", true);
      Promise.all([this.getChartOfAccount(), this.getSubconInvoice(), this.getSubcon()])
        .then(() => this.$store.commit("SET_LOADER", false))
        .catch(() => {
          this.$store.dispatch("toast", {
            type: "error",
            message: "Ada masalah dengan aplikasi, mohon hubungi admin aplikasi",
          });
          this.$store.commit("SET_LOADER", false);
        });
    },
  },
  mounted() {
    this.getInitialData();
  },
};
</script>

<style></style>
